export function intlLocale(locale) {
  return locale === 'id' ? 'id-ID' : 'en-US'
}

export function statusLabel(vm, status) {
  if (!status) return '-'
  const key = `status.${status}`
  return vm.$te(key) ? vm.$t(key) : status.replace(/_/g, ' ')
}

export function weekdayOptions(vm) {
  return [0, 1, 2, 3, 4, 5, 6].map((value) => ({
    value,
    label: vm.$t(`common.days.${value}`),
  }))
}
